import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';

export default function Footer() {
    let date = new Date();

    return (
        <>
            <footer>
                <Container fluid>
                    <Row>
                        <Col sm='12'>
                            <p>
                                © {date.getFullYear()} این یک نمونه کار است که
                                توسط{' '}
                                <a href='https://amirreza.dev'>
                                    امیررضا کدخدازاده
                                </a>{' '}
                                طراحی شده. تمامی حقوق مادی و معنوی این قالب
                                محفوظ و هر گونه کپی برداری پیگرد قانونی دارد.
                            </p>
                        </Col>
                    </Row>
                </Container>
            </footer>
        </>
    );
}
